import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import TopBar from './TopBar';
import './JoinAsVendorPage.css';
import { useAuth } from '../context/AuthContext';
import { createVendorApplication, getVendorApplicationByProfileId, isVendorNameTaken } from '../services/vendorApplicationService';

// Import the hero image
import HeroImage from './JoinAsVendor(main).jpg';
import LocalCommunity from './local-community.jpg';
import ExtraIncome from './extra-income.jpg';
import PreventFoodWastage from './prevent-food-wastage.jpg';

// SVG Icons
const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM8.5 14.5L4 10L5.41 8.59L8.5 11.67L14.59 5.59L16 7L8.5 14.5Z" fill="#084820" />
  </svg>
);

const UserIcon = () => (
  <svg width="38" height="30" viewBox="0 0 38 30" fill="none">
    <path d="M19 15C22.866 15 26 11.866 26 8C26 4.134 22.866 1 19 1C15.134 1 12 4.134 12 8C12 11.866 15.134 15 19 15ZM19 18.5C14.03 18.5 4 21 4 26V29H34V26C34 21 23.97 18.5 19 18.5Z" fill="#084820" />
  </svg>
);

const ListIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path d="M3.75 22.5H11.25V20H3.75V22.5ZM3.75 7.5V10H26.25V7.5H3.75ZM3.75 16.25H18.75V13.75H3.75V16.25Z" fill="#084820" />
  </svg>
);

const BellIcon = () => (
  <svg width="26" height="30" viewBox="0 0 26 30" fill="none">
    <path d="M13 30C14.65 30 16 28.65 16 27H10C10 28.65 11.35 30 13 30ZM23 21V13.5C23 8.635 20.36 4.575 15.75 3.5V2.25C15.75 0.9 14.35 0 13 0C11.65 0 10.25 0.9 10.25 2.25V3.5C5.625 4.575 3 8.625 3 13.5V21L0 24V25.5H26V24L23 21Z" fill="#084820" />
  </svg>
);

const DeliverIcon = () => (
  <svg width="38" height="30" viewBox="0 0 38 30" fill="none">
    <path d="M31.5 6.5H26.5V0H3C1.35 0 0 1.35 0 3V24H3C3 26.75 5.25 29 8 29C10.75 29 13 26.75 13 24H23C23 26.75 25.25 29 28 29C30.75 29 33 26.75 33 24H36V14.5L31.5 6.5ZM8 26.5C6.625 26.5 5.5 25.375 5.5 24C5.5 22.625 6.625 21.5 8 21.5C9.375 21.5 10.5 22.625 10.5 24C10.5 25.375 9.375 26.5 8 26.5ZM30.5 9L33.75 14.5H26.5V9H30.5ZM28 26.5C26.625 26.5 25.5 25.375 25.5 24C25.5 22.625 26.625 21.5 28 21.5C29.375 21.5 30.5 22.625 30.5 24C30.5 25.375 29.375 26.5 28 26.5Z" fill="#084820" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 0L0 3.636V9.09C0 14.14 4.27 18.86 10 20C15.73 18.86 20 14.14 20 9.09V3.636L10 0Z" fill="#1b4e1f" />
  </svg>
);

const CreditIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="4" width="20" height="16" rx="2" stroke="#1b4e1f" strokeWidth="2" />
    <path d="M2 10H22" stroke="#1b4e1f" strokeWidth="2" />
    <path d="M6 15H10" stroke="#1b4e1f" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const StarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="#1b4e1f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

const ClockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#1b4e1f" strokeWidth="2" />
    <path d="M12 6V12L16 14" stroke="#1b4e1f" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SecureIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L4 5V11C4 16.5 7.5 21.5 12 23C16.5 21.5 20 16.5 20 11V5L12 2Z" stroke="#1b4e1f" strokeWidth="2" />
    <path d="M9 12L11 14L15 10" stroke="#1b4e1f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Hero Section Component
function HeroSection() {
  return (
    <section className="vendor-hero-section">
      <div className="vendor-hero-content">
        <div className="vendor-hero-text">
          <h1 className="vendor-hero-title">
            Sell Fresh Homemade Food To Your Neighbours
          </h1>
          <p className="vendor-hero-description">
            Turn your cooking passion into profit. Connect with your community
            and share delicious homemade meals with neighbors who appreciate
            authentic, fresh food.
          </p>
          <button className="vendor-hero-cta" onClick={() => {
            document.getElementById('application-form').scrollIntoView({ behavior: 'smooth' });
          }}>
            Start Selling Today
          </button>
          <div className="vendor-hero-badges">
            <ShieldIcon />
            <span>Verified vendors only • Safe payments • Community-driven</span>
          </div>
        </div>
        <div className="vendor-hero-image-container">
          <img src={HeroImage} alt="Fresh homemade food" className="vendor-hero-image" />
        </div>
      </div>
    </section>
  );
}

// Why Sell Section Component
function WhySellSection() {
  const benefits = [
    {
      id: 1,
      title: 'Local Community',
      description: 'Sell directly to your neighbors and build relationships within your condo community.',
      image: LocalCommunity  // Changed from null
    },
    {
      id: 2,
      title: 'Extra Income',
      description: 'Turn your cooking skills into a profitable side business with flexible hours that work for you.',
      image: ExtraIncome  // Changed from null
    },
    {
      id: 3,
      title: 'Prevent Food Wastage',
      description: 'Turn extra ingredients into meals your neighbours will enjoy instead of letting them go to waste.',
      image: PreventFoodWastage  // Changed from null
    }
  ];

  return (
    <section className="why-sell-section">
      <h2 className="section-title">Why Sell on Condo Eats?</h2>
      <div className="benefits-container">
        {benefits.map(benefit => (
          <div key={benefit.id} className="benefit-card">
            <div className="benefit-image-placeholder">
              <img src={benefit.image} alt={benefit.title} className="benefit-image" />
            </div>
            <h3 className="benefit-title">{benefit.title}</h3>
            <p className="benefit-description">{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

// How It Works Section Component
function HowItWorksSection() {
  const steps = [
    {
      number: 1,
      icon: <UserIcon />,
      title: 'Sign Up',
      description: 'Create your vendor account and wait for verification through WhatsApp'
    },
    {
      number: 2,
      icon: <ListIcon />,
      title: 'List Items',
      description: 'Upload photos and descriptions of your homemade dishes'
    },
    {
      number: 3,
      icon: <BellIcon />,
      title: 'Get Orders',
      description: 'Receive notifications when neighbors place orders'
    },
    {
      number: 4,
      icon: <DeliverIcon />,
      title: 'Deliver',
      description: 'Prepare and deliver fresh food to your neighbors'
    }
  ];

  return (
    <section className="how-it-works-section">
      <h2 className="section-title">How It Works</h2>
      <div className="steps-container">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className="step-item">
              <div className="step-number">{step.number}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
            {index < steps.length - 1 && <div className="step-connector"></div>}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

// Requirements Section Component
function RequirementsSection() {
  const requirements = [
    'Live in a participating condo',
    'Valid government ID',
    'Clean kitchen space (strictly no pets)',
    'Reliable communication'
  ];

  return (
    <section className="requirements-section">
      <div className="requirements-container">
        <h2 className="section-title">Requirements</h2>
        <div className="requirements-card">
          <div className="requirements-grid">
            {requirements.map((req, index) => (
              <div key={index} className="requirement-item">
                <CheckIcon />
                <span>{req}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// Vendor Application Form Component
function VendorApplicationForm() {
  const { user, profile } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    whatsappNumber: '',
    vendorName: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitMessageType, setSubmitMessageType] = useState(''); // 'success' | 'error'
  const [existingApplication, setExistingApplication] = useState(null);
  const [checkingApplication, setCheckingApplication] = useState(true);

  // Check for existing application on load
  useEffect(() => {
    const checkApplication = async () => {
      if (profile?.$id) {
        try {
          // Dynamic import to avoid circular dependencies if any, though likely safe to import at top
          // deeper access to the service
          const app = await getVendorApplicationByProfileId(profile.$id);
          setExistingApplication(app);
        } catch (error) {
          console.error('Error checking existing application:', error);
        } finally {
          setCheckingApplication(false);
        }
      } else {
        setCheckingApplication(false);
      }
    };

    if (profile) {
      checkApplication();
    } else {
      // No profile (user not logged in) — stop showing the loading spinner
      setCheckingApplication(false);
    }
  }, [profile]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    setSubmitMessageType('');

    try {
      // Require an authenticated profile so we can write the FK `userprofile_id`
      if (!profile || !user) {
        // Redirect to login with a message
        navigate('/login', {
          state: {
            message: 'Please log in to submit your vendor application',
            redirectTo: '/vendor'
          }
        });
        setIsSubmitting(false);
        return;
      }

      // Check vendor name uniqueness (exclude current user's profile if any)
      const nameTaken = await isVendorNameTaken(formData.vendorName, profile.$id);
      if (nameTaken) {
        setSubmitMessage('Vendor name is already taken by another vendor. Please choose a different vendor name.');
        setSubmitMessageType('error');
        setIsSubmitting(false);
        return;
      }

      const payload = {
        userprofile_id: profile.$id,
        full_name: formData.fullName,
        vendor_name: formData.vendorName,
        contact_email: formData.email,
        whatsapp_number: formData.whatsappNumber,
        status: 'pending'
      };

      const doc = await createVendorApplication(payload, { userId: user.$id });

      // Update local state so UI updates immediately
      setExistingApplication(doc);

      setSubmitMessage("Application submitted successfully! We'll contact you within 2-3 business days.");
      setSubmitMessageType('success');
      setFormData({ fullName: '', email: '', whatsappNumber: '', vendorName: '' });
    } catch (error) {
      console.error('Vendor application submit failed:', error);
      const message = error?.message || 'Failed to submit application. Please try again later.';
      setSubmitMessage(message);
      setSubmitMessageType('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (checkingApplication) {
    return (
      <section className="application-section" id="application-form">
        <div className="application-container">
          <div className="loading-spinner">Loading application status...</div>
        </div>
      </section>
    );
  }

  // If already applied and pending
  if (existingApplication && existingApplication.status === 'pending') {
    return (
      <section className="application-section" id="application-form">
        <div className="application-container">
          <div className="application-info">
            <h2 className="application-title">Application Status</h2>
            <div className="status-card pending">
              <ClockIcon />
              <h3>Application Pending</h3>
              <p>
                You have already submitted a vendor application.
                Our team is currently reviewing your details.
                Vendor name: {existingApplication.vendor_name}.
                We will contact you via WhatsApp ({existingApplication.whatsapp_number})
                or Email ({existingApplication.contact_email}) once verified.
              </p>
              <p className="status-note">Submitted on: {new Date(existingApplication.$createdAt).toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // If approved
  if (existingApplication && existingApplication.status === 'approved') {
    return (
      <section className="application-section" id="application-form">
        <div className="application-container">
          <div className="application-info">
            <h2 className="application-title">Application Approved!</h2>
            <div className="status-card success">
              <CheckIcon />
              <h3>You are a Verified Vendor</h3>
              <p>
                Congratulations! Your vendor application has been approved.
                You can now start listing your food items and selling to your community.
              </p>
              <Link to="/start-selling" className="vendor-hero-cta" style={{ marginTop: '20px', display: 'inline-block', textDecoration: 'none' }}>
                Go to Vendor Dashboard
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="application-section" id="application-form">
      <div className="application-container">
        <div className="application-info">
          <h2 className="application-title">Ready to Start Selling?</h2>
          <p className="application-subtitle">
            Join our community of home chefs and start earning money doing what you love.
          </p>
          <div className="application-benefits">
            <div className="app-benefit-item">
              <CreditIcon />
              <span>Payment through a built-in e-wallet system</span>
            </div>
            <div className="app-benefit-item">
              <StarIcon />
              <span>No upfront costs or monthly fees</span>
            </div>
            <div className="app-benefit-item">
              <ClockIcon />
              <span>Set your own schedule and prices</span>
            </div>
            <div className="app-benefit-item">
              <SecureIcon />
              <span>Secure payments and support</span>
            </div>
          </div>
        </div>
        <div className="application-form-container">
          <h3 className="form-title">Vendor Application</h3>
          {!user && (
            <div className="login-prompt">
              <p>
                Please <Link to="/login" onClick={() => navigate('/login', { state: { redirectTo: '/vendor', message: 'Please log in to submit your vendor application' } })}>log in</Link> to submit the vendor application.
              </p>
              <button
                type="button"
                className="vendor-hero-cta"
                onClick={() => navigate('/login', { state: { redirectTo: '/vendor', message: 'Please log in to submit your vendor application' } })}
              >
                Log in to Apply
              </button>
            </div>
          )}
          <form onSubmit={handleSubmit} className="vendor-form">
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                autoComplete="name"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="vendorName">Vendor Name (must be unique, case insensitive)</label>
              <input
                type="text"
                id="vendorName"
                name="vendorName"
                value={formData.vendorName}
                onChange={handleChange}
                placeholder="Name to be displayed to customers"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address (notifications about your food sales will be sent here, you can disable this in your orders page under "Customer Orders")</label>
              <input
                type="email"
                id="email"
                name="email"
                autoComplete="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="whatsappNumber">WhatsApp Number</label>
              <input
                type="tel"
                id="whatsappNumber"
                name="whatsappNumber"
                autoComplete="tel"
                inputMode="tel"
                value={formData.whatsappNumber}
                onChange={handleChange}
                placeholder="Enter your WhatsApp number"
                required
              />
            </div>
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting || !user}
            >
              {isSubmitting ? 'Submitting...' : (user ? 'Submit Application' : 'Log in to Submit')}
            </button>
            {submitMessage && (
              <div className={`submit-message ${submitMessageType}`}>{submitMessage}</div>
            )}
            <p className="form-disclaimer">
              By submitting, you agree to our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>.
              We'll review your application within 2-3 business days.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}

// Main JoinAsVendorPage Component
export default function JoinAsVendorPage() {
  const location = useLocation();
  const [infoMessage, setInfoMessage] = useState('');

  // Get redirect message from navigation state
  useEffect(() => {
    if (location.state?.message) {
      setInfoMessage(location.state.message);
    }
  }, [location]);

  return (
    <div className="join-vendor-page">
      <TopBar />
      {infoMessage && (
        <div className="page-info-banner">
          {infoMessage}
        </div>
      )}
      <main className="vendor-main">
        <HeroSection />
        <WhySellSection />
        <HowItWorksSection />
        <RequirementsSection />
        <VendorApplicationForm />
      </main>
    </div>
  );
}
